import React from "react";
import "./CouponBanner.css";

const CouponBanner = () => {
  return (
    <div className="coupon-banner">
      <span>🔥 Flat 10% OFF </span>
      <strong>- Use Code: SAVE10</strong>
    </div>
  );
};

export default CouponBanner;
